export const displayActionCardHeader = (header = '') => {
  return (
    <div className="row">
      <div className="col-12 col-lg-12 d-flex justify-content-between mt-3 mb-1">
        <div className="d-flex align-items-center justify-content-start">
          <h5 className="F-size14 text-bold mb-0"> {header}</h5>
        </div>
      </div>
    </div>
  );
};
